<template>
  <div class="mobile-tabs" role="tablist" aria-label="Idea Status Tabs">
    <button
      v-for="item in items"
      :key="item.index"
      class="tab-chip"
      :class="{ active: String(item.index) === activeIndex }"
      role="tab"
      :aria-selected="String(item.index) === activeIndex"
      @click="$emit('select', String(item.index))"
    >
      <span class="status-dot" :style="{ backgroundColor: getStatusColor(item.index) }"></span>
      <span class="label">{{ item.label }}</span>
    </button>
  </div>
</template>

<style scoped>
.mobile-tabs {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding: 8px 12px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}

.mobile-tabs::-webkit-scrollbar {
  display: none;
}

.tab-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  min-height: 48px; /* 提升触控面积至 48px */
  min-width: 80px; /* 防止文字被过度压缩 */
  flex-shrink: 0; /* 禁止在窄屏下压缩，确保文字完整显示 */
  border-radius: 999px;
  background: #ffffff;
  color: #484851;
  border: 1px solid rgba(201, 201, 207, 0.6);
  scroll-snap-align: start;
  white-space: nowrap;
}

.tab-chip.active {
  background: rgba(243, 102, 51, 0.1);
  color: #f36633;
  border-color: #f36633;
}

.status-dot {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.label {
  font-size: 16px;
  font-weight: 700;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import { getStatusColor } from "@/utils/getStatusColor";
import { getStatusText } from "@/utils/getStatusText";

export default defineComponent({
  name: "MobileStatusTabs",
  props: {
    activeIndex: {
      type: String,
      default: "1",
    },
  },
  emits: ["select"],
  setup() {
    const items = [1, 2, 3, 4, 5, 6].map((i) => ({ index: i, label: getStatusText(i) }));
    return {
      items,
      getStatusColor,
    };
  },
});
</script>